import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import I18n from 'i18n-react';
import './Login.css';
import ForgotPasswordModal from './components/ForgotPasswordModal';

const ENTER_KEYEVENT = 'enter';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  showLoginLoading: PropTypes.bool
};

const defaultProps = {
  showLoginLoading: false
};

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoginFilled: true,
      isPasswordFilled: true,
      isButtonDisabled: true,
      login: '',
      password: '',
      isModalVisibility: false
    };

    this.handleFormKeyUp = this.handleFormKeyUp.bind(this);
    this.changeModalState = this.changeModalState.bind(this);
  }

  setDisabledButton(){
    if (this.props.termIsChecked && this.state.isLoginFilled && this.state.isPasswordFilled){
      return false ;
    }
    return true ;
  }

  changeModalState = () => {    
      this.setState({
        isModalVisibility: true
      });    
  };

  renderLogin() {
    return (
      <div className="Login__container">
        <Row className="Field__label">
          <Col id={`${this.props.id}_loginLabel`} xs={12}>
            <span
              className={this.state.isLoginFilled ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate('components.login.loginLabel')}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="Login__input">
            <input
              type="text"
              id={`${this.props.id}_loginField`}
              onChange={this.handleLoginChange}
              onBlur={this.validateLogin}
              placeholder={I18n.translate('components.login.loginPlaceholder')}
              className={`Field__input ${
                this.state.isLoginFilled ? 'Field__validInput' : 'Field__invalidInput'
              }`}
              value={this.state.login}
              maxLength={11}
              minLength={10}
            />
          </Col>
        </Row>
        {this.renderValidationMessage(this.state.isLoginFilled, 'components.login.cpfErrorMessage')}
      </div>
    );
  }

  renderPassword() {
    return (
      <div className="Login__container">
        <Row className="Field__label">
          <Col id={`${this.props.id}_passwordLabel`} xs={12}>
            <span
              className={this.state.isPasswordFilled ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate('components.login.passwordLabel')}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="Login__input">
            <input
              type="password"
              id={`${this.props.id}_passwordField`}
              onChange={this.handlePasswordChange}
              onBlur={this.validatePassword}
              placeholder={I18n.translate('components.login.passwordPlaceholder')}
              className={`Field__input ${
                this.state.isPasswordFilled ? 'Field__validInput' : 'Field__invalidInput'
              }`}
              value={this.state.password}
              maxLength={18}
            />
          </Col>
        </Row>
        {this.renderValidationMessage(
          this.state.isPasswordFilled,
          'components.login.passwordErrorMessage'
        )}
        <Row>
          <Col xsHidden mdOffset={7} md={4} className="text-right Login__forgotPassword">
            <a
              onClick={() => {
                this.changeModalState()
               }} 
              className="Login__forgotPasswordLabel"              
              rel="noopener noreferrer">
              {I18n.translate('components.login.forgotPassword')}
            </a>
          </Col>
        </Row>
      </div>
    );
  }

  renderValidationMessage(isFieldFilled, message) {
    let footer = <Row id={`${this.props.id}__errorMessageFooter`} className="Field__message" />;

    if (!isFieldFilled) {
      footer = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}__errorMessageFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(message)}</span>
          </Col>
        </Row>
      );
    }

    return footer;
  }

  handleFormKeyUp(event) {
    if (event.key.toLowerCase() === ENTER_KEYEVENT) {
      this.validate(event);
    }
  }

  validate = event => {
    event.preventDefault();
    let isLoginValid = this.validateLogin();
    let isPasswordValid = this.validatePassword();
    let isValid = isLoginValid && isPasswordValid && this.props.termIsChecked;
    if (isValid) {
      this.props.changeValue(this.state.login, this.state.password);
    }else {
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    return isValid;
  };

  handleLoginChange = event => {
    let isButtonDisabled = true;
    if(!this.props.termIsChecked){
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    if (event.target.value && this.state.password && this.props.termIsChecked) {
      isButtonDisabled = false;
    }
    this.setState({
      login: event.target.value,
      isButtonDisabled: isButtonDisabled
    });
  };

  handlePasswordChange = event => {
    let isButtonDisabled = true;
    if(!this.props.termIsChecked){
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    if (this.state.login && event.target.value && this.props.termIsChecked) {
      isButtonDisabled = false;
    }
    this.setState({
      password: event.target.value,
      isButtonDisabled: isButtonDisabled
    });
  };

  validateLogin = () => {
    let isValidState = this.state.login.length > 9;

    this.setState({
      isLoginFilled: isValidState
    });

    return isValidState;
  };

  validatePassword = () => {
    let isValidState = this.state.password.length > 0;

    this.setState({
      isPasswordFilled: isValidState
    });

    return isValidState;
  };

  render() {
    let loginWrapperClass =
      'Login__backgroundMobile ' + (this.props.showLoginLoading ? 'Login__withLoading' : '');
    return (
      <div>
      <form id={this.props.id} onSubmit={this.validate} onKeyUp={this.handleFormKeyUp}>
        <hr />
        <Row className={loginWrapperClass}>
          <Col xs={10} xsOffset={1} mdOffset={0} md={5} className="Login__titleContainer">
            <label className="Login__title">
              {I18n.translate('components.login.titleOneLine')}
              <br />
              {I18n.translate('components.login.titleSecondLine')}
              <br />
              {I18n.translate('components.login.titleThirdLine')}
            </label>
          </Col>

          <Col xs={12} md={7} className="Login__background">
            <Row>
              <Col xs={10} xsOffset={1} md={5} className="Login__inputLogin">
                {this.renderLogin()}
              </Col>
              <Col xs={10} xsOffset={1} mdOffset={0} md={5}>
                {this.renderPassword()}
              </Col>
              <Col
                xs={10}
                xsOffset={1}
                smHidden
                mdHidden
                lgHidden
                className="Login__forgotPassword">
                <a
                 onClick={() => {
                  this.changeModalState()
                 }}  
                  className="Login__forgotPasswordLabel"                  
                  rel="noopener noreferrer">
                  {I18n.translate('components.login.forgotPassword')}
                </a>
              </Col>
              <Col xs={12} mdOffset={0} md={1} className="text-center">
                <Button
                  id="btnLogin"
                  type="submit"
                  className="btnOkLogin"
                  disabled={this.setDisabledButton()}>
                  {I18n.translate('components.login.buttonOk')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
      </form>
      <ForgotPasswordModal
         close={() => {
          this.setState({
          isModalVisibility: false
         })
        }}
        showModal={this.state.isModalVisibility}
      />
    </div>
    );
  }
}

Login.propTypes = propTypes;
Login.defaultProps = defaultProps;

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/Login.jsx